var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStackingRacking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/stacking-racking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/stacking-racking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.402224,20 C83.78252,20 84.9101906,21.0745823 84.9948926,22.4322187 L85,22.5964431 L85,85.9200655 C85,87.3542405 83.8377318,88.5165086 82.402224,88.5165086 C81.0232096,88.5165086 79.8955883,87.4419264 79.8108882,86.0842899 L79.8057809,85.9200655 L79.8057809,82.5798774 L20.1928862,82.5798774 L20.1928862,85.9200655 C20.1928862,87.3542405 19.0306181,88.5165086 17.5964431,88.5165086 C16.2161471,88.5165086 15.0897089,87.4419264 15.0051016,86.0842899 L15,85.9200655 L15,22.5964431 C15,21.1622682 16.1609353,20 17.5964431,20 C18.9754575,20 20.1030788,21.0745823 20.1877789,22.4322187 L20.1928862,22.5964431 L20.1928862,46.2203435 L79.8057809,46.2203435 L79.8057809,22.5964431 C79.8057809,21.1622682 80.968049,20 82.402224,20 Z M79.8057809,51.4132297 L20.1928862,51.4132297 L20.1928862,77.3856583 L79.8057809,77.3856583 L79.8057809,51.4132297 Z M41.3842873,56.2382421 L41.3842873,74.046803 L23.2851594,74.046803 L23.2851594,56.2382421 L41.3842873,56.2382421 Z M62.3877528,56.2382421 L62.3877528,74.046803 L44.2899577,74.046803 L44.2899577,56.2382421 L62.3877528,56.2382421 Z M76.0630641,63.6423702 L76.0630641,74.046803 L65.489356,74.046803 L65.489356,63.6423702 L76.0630641,63.6423702 Z M41.8574584,25.0715945 L41.8574584,42.8801554 L23.7583305,42.8801554 L23.7583305,25.0715945 L41.8574584,25.0715945 Z M55.5327697,32.4757226 L55.5327697,42.8801554 L44.9590617,42.8801554 L44.9590617,32.4757226 L55.5327697,32.4757226 Z",
    id: "stacking-racking",
    fill: "#1C7B97"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackingRacking);
export default __webpack_public_path__ + "static/media/stacking-racking.43b7726b.svg";
export { ForwardRef as ReactComponent };